module.exports = __webpack_public_path__ + "c2ee2b6f9dc036f1ec89605671ba6ca5.png";